import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { TEST_URL } from '@/api/config/api.config';

export interface IAppSettings {
  show_prices: boolean;
}

export const settingsApi = createApi({
  reducerPath: 'settingsApi',
  baseQuery: fetchBaseQuery({ baseUrl: TEST_URL, credentials: 'include' }),
  endpoints: (builder) => ({
    getSettings: builder.query<IAppSettings, void>({
      query: () => ({ url: '/settings' }),
    }),
  }),
});

export const { useGetSettingsQuery } = settingsApi;
